"use client";

import { useEffect, useRef } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { setAnalyticsUser } from "@/lib/analytics";

export default function AnalyticsUserSync(): null {
  const { user } = useAuth();
  const hadUser = useRef(false);
  useEffect(() => {
    if (user) {
      hadUser.current = true;
      setAnalyticsUser(user);
    } else if (hadUser.current) {
      hadUser.current = false;
      setAnalyticsUser(null);
    }
  }, [user]);
  return null;
}
